import { theme as gTheme } from 'theme';

export const selectStyles = (isFocused?: boolean, error?: boolean) => ({
  container: (provided: any) => ({
    ...provided,
    width: '100%'
  }),
  control: (provided: any, styleState: any) => {
    return {
      ...provided,
      minHeight: 'unset',
      boxSizing: 'content-box',
      boxShadow: 'none',
      border: `1px solid ${styleState.menuIsOpen || isFocused ? gTheme.option.active.color : gTheme.option.borderColor}`,
      borderRadius: '.4rem',
      transition: `border ${gTheme.animSpeed}`,
      '&:focus, &:active, &:hover': {
        borderColor: styleState.isFocused ? gTheme.option.active.color : ''
      },
      ...(error && {
        border: `1px solid ${gTheme.colors.accentTertiary}`,
        '&:focus, &:active, &:hover': {
          borderColor: gTheme.colors.accentTertiary
        },
      })
    };
  },
  menu: (provided: any, styleState: any) => ({
    ...provided,
    zIndex: gTheme.layers.highest
  }),
  menuPortal: (provided: any, styleState: any) => ({
    ...provided,
    zIndex: gTheme.layers.highest
  }),
  singleValue: (provided: any, styleState: any) => ({
    ...provided,
  })
});

export const getTheme = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: gTheme.option.active.color,
    primary25: gTheme.colors.corePrimaryLighter2,
    danger: gTheme.colors.accentTertiary,
    dangerLight: `${gTheme.colors.accentTertiary}44`,
  },
});
